import { useEffect, useRef } from 'react';

/**
 * Pestañas de una pantalla (App de pacientes, Administración, Comisiones, Analítica, Reglas y datos…).
 * En celular van en UN renglón que se desliza (antes eran botones grandes en 4–6 renglones que llenaban la
 * pantalla) y la pestaña elegida se asoma sola; en pantalla ancha se acomodan en varios renglones.
 * Cada botón conserva `data-tab` (lo usan las pruebas y las ligas `?tab=`).
 *
 * Con muchas pestañas (App de pacientes tiene 11), cada una puede traer un tercer elemento: su GRUPO ("Programa",
 * "Ventas"…). El nombre del grupo sale chiquito antes de su primera pestaña: once botones iguales se leen como un
 * muro; en cuatro grupos se encuentra cada cosa a la primera.
 */
export function Pestanas<K extends string>({ items, valor, onCambio, etiqueta = 'Secciones', estilo }: {
  items: readonly (readonly [K, string] | readonly [K, string, string])[]; valor: K; onCambio: (k: K) => void; etiqueta?: string; estilo?: React.CSSProperties;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const b = ref.current?.querySelector<HTMLElement>('[aria-selected="true"]');
    const cont = ref.current;
    if (b && cont && cont.scrollWidth > cont.clientWidth) cont.scrollTo({ left: Math.max(0, b.offsetLeft - 24), behavior: 'smooth' });
  }, [valor]);
  return (
    <div ref={ref} className="hub-tabs" role="tablist" aria-label={etiqueta} style={estilo}>
      {items.map((it, i) => {
        const [k, l] = it; const g = it[2]; const nuevo = g && g !== items[i - 1]?.[2];
        return [
          nuevo ? <span key={`g:${g}`} className="hub-tabs-grupo" aria-hidden="true">{g}</span> : null,
          <button key={k} type="button" role="tab" aria-selected={valor === k} className="btn-ghost" data-tab={k} onClick={() => onCambio(k)}>{l}</button>,
        ];
      })}
    </div>
  );
}
